import { render, staticRenderFns } from "./adsAccount.vue?vue&type=template&id=d59f9972&scoped=true&"
import script from "./adsAccount.vue?vue&type=script&lang=js&"
export * from "./adsAccount.vue?vue&type=script&lang=js&"
import style0 from "./adsAccount.vue?vue&type=style&index=0&id=d59f9972&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59f9972",
  null
  
)

export default component.exports